import React, { useState, useEffect } from "react";
import "./WalletOp.css";
import { useTonConnectUI, useTonWallet } from "@tonconnect/ui-react";
import {
  makeWalletOp,
  deleteWalletAddress,
  redicrectAuth,
  fetchBalance,
  saveWallet,
} from "../../api";

const Input = ({ title, operation, setOpen, check }) => {
  const [amount, setAmount] = useState("");

  const [error, setError] = useState("");

  const handleAmountChange = (e) => {
    const value = e.target.value;
    console.log(value);
    if (/^(0|[1-9]\d{0,5})(\.\d{0,4})?$/.test(value) || value === "") {
      setAmount(value);
    }
    setError("");
  };

  const onUpdated = async (newAmount) => {
    setOpen(true);
  };

  const errorWrapper = async (err) => {
    setError(err);
  };

  const walletRequest = async () => {
    if (!amount || isNaN(amount) || Number(amount) <= 0) {
      errorWrapper("Enter a valid amount");
      return;
    }
    const err = check(Number(amount));
    if (err) {
      errorWrapper(err);
      return;
    }
    try {
      makeWalletOp(operation, amount, onUpdated, errorWrapper);
    } catch (error) {
      errorWrapper("Failed to execute the request. Please try again.");
      console.error(error);
    }
  };

  return (
    <div>
      <div className="input-title">{title}</div>
      {error && <p className="error">{error}</p>}
      <div className="input-amount">
        <img className="icon2" src="/ton.png" alt="Icon" />
        <input
          className="input-amount-input"
          value={amount}
          onChange={handleAmountChange}
          type="text"
        />
      </div>
      <div className="confirm-container">
        <button className="confirm-button" onClick={walletRequest}>
          Confirm
        </button>
      </div>
    </div>
  );
};

const DicsonnectView = ({ onError }) => {
  const wallet = useTonWallet();
  const connected = wallet?.account?.address != undefined;
  const [tonConnectUi] = useTonConnectUI();
  const [wConnected, setWConnected] = useState(null);

  useEffect(() => {
    if (wallet?.account?.address) {
      console.log(wallet.appName);
      console.log(wallet.account?.address);
      saveWallet(
        wallet.account?.address,
        wallet.appName,
        setWConnected,
        onError
      );
    }
  }, [wallet, tonConnectUi]);

  const onClick = () => {
    deleteWalletAddress((d) => {
      tonConnectUi.disconnect();
    }, onError);
  };

  return (
    <div>
      {connected && (
        <button className="disButton" onClick={onClick}>
          Disconnect wallet
        </button>
      )}
      {!connected && (
        <button className="disButton" onClick={() => tonConnectUi.openModal()}>
          Connect wallet for easy deposit and withdrawal
        </button>
      )}
    </div>
  );
};

const ConfirmAndExitSection = ({ back }) => {
  const onOk = () => {
    fetchBalance(
      (d) => back(),
      (err) => {}
    );
  };
  return (
    <div className="overlay">
      <div className="modal">
        <p className="modal-title">Request created!</p>
        <p className="modal-text">Proceed in the Telegram</p>
        <div className="create-container">
          <button className="ok" onClick={onOk}>
            Ок
          </button>
        </div>
      </div>
    </div>
  );
};

const WalletOp = ({}) => {
  const balance = localStorage.getItem("balance");
  const [open, setOpen] = useState(false);

  if (redicrectAuth()) {
    window.location.href = "/";
  }

  const back = () => {
    window.location.href = `/menu`;
  };
  const [error, setError] = useState("");

  return (
    <div>
      <div className="container2">
        <button className="backbutton" onClick={back}>
          <img className="imagebackbutton" src="/home.svg" alt="Home" />
        </button>
        <div className="balance-text2">{parseFloat(balance).toFixed(2)}</div>
      </div>
      <Input
        title={"Deposit"}
        operation={"deposit"}
        setOpen={setOpen}
        check={(_) => ""}
      />
      <Input
        title={"Withdraw"}
        operation={"withdraw"}
        setOpen={setOpen}
        check={(amount) => {
          return amount >= 25 ? "" : "Minimal withdrawal is 25 TON";
        }}
      />
      <DicsonnectView onError={setError} />

      {error && <p className="error">{error}</p>}
      {open && <ConfirmAndExitSection back={back} />}
    </div>
  );
};

export default WalletOp;
